<div>
  <ag-grid-angular #drillGroupsSelectionGrid style="height: 365px;" class="ag-theme-balham"
    [gridOptions]="drillGroupMappingGridOptions" (gridReady)="onGridReady($event)" (filterChanged)="onFilterChanged($event)"
    (selectionChanged)="onSelectionChanged($event)">
  </ag-grid-angular>
</div>